import axios from "axios";
import { API } from "./client";

/**
 * Send a chat message to the AI File Explorer Agent.
 */
export async function sendFileChat(
  sessionId,
  message,
  files = [],
  currentPath = [],
  currentFolderId = null,
  currentProjectId = null,
) {
  const fileItems = files.map((f) => ({
    id: f.id,
    name: f.name,
    folder: Boolean(f.folder),
    size: f.size ?? null,
    lastModifiedDateTime: f.lastModifiedDateTime ?? null,
    depth: f._depth ?? 0,
    parentName: f._parentName ?? null,
    badge: f._badge ?? null,
  }));

  const res = await axios.post(`${API}/files/chat`, {
    session_id: sessionId,
    message,
    files: fileItems,
    current_path: currentPath,
    current_folder_id: currentFolderId,
    current_project_id: currentProjectId,
  });
  return {
    ...res.data,
    results: Array.isArray(res.data.results) ? res.data.results : [],
    retrieval_status: res.data.retrieval_status || null,
  };
}

/**
 * Clear the AI chat session on the backend.
 */
export async function clearFileChat(sessionId) {
  await axios.delete(`${API}/files/chat/${sessionId}`);
}


/**
 * Apply a user-approved layout modification to a project's folder structure.
 * Only called after the user explicitly approves the change.
 */
export async function applyLayoutModification(projectId, modification, changes) {
  const res = await axios.post(`${API}/files/apply-layout-modification`, {
    project_id: projectId,
    modification,
    changes,
  });
  return res.data;
}
